import React, { useState } from 'react'

import { twMerge } from 'tailwind-merge'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './ui/tooltip'

interface Prop {
  isHover?: boolean
  trigger: string | JSX.Element
  twClass?: string
  children: React.ReactNode
}

function BaseTooltip({ isHover = false, trigger, children, twClass }: Prop) {
  const [open, setOpen] = useState(false)
  return (
    <TooltipProvider>
      <Tooltip delayDuration={300} open={isHover ? undefined : open}>
        <TooltipTrigger
          asChild
          onClick={() => {
            setOpen(pre => !pre)
          }}
          onBlur={() => {
            setOpen(false)
          }}
          className="flex items-center justify-center"
        >
          {trigger}
        </TooltipTrigger>
        <TooltipContent
          side="top"
          align="start"
          className={twMerge(
            'overlay-fix text-background-b1 relative z-[999] overflow-visible rounded-xl border-0 bg-[#515656] p-0',
            twClass,
          )}
        >
          {children}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

export default BaseTooltip
